/**
 * Logout View
 */

define(function(require, exports, module) {
    'use strict';
    var core = require('core');
    var LogoutReplacerView = require('replacers/logout/logout.view.js');

    module.exports = LogoutReplacerView.extend({

        /**
         * Start logout action
         */
        logout: function() {
            window.Playtech.API?.sidebar?.close?.(); // { Lugano changes }
            core.trigger('auth:action:logout');
        }

    });
});